import React, { useEffect, useState } from "react";
import { Link, useRouteMatch, withRouter } from "react-router-dom";
import Chevron from "../../Assets/down-chevron.svg";
import Style from "./style";
import Select from "react-select";
import Loader from "../Loader";
import Radio from "../../Assets/radio.svg";

// redux
import { connect } from "react-redux";
import {
  AddQuestion,
  GetQuestionDetails,
  EditQuestions,
  DeleteQuestion,
} from "../../Redux/Actions/QuestionAction";
import Modal from "../Modal";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

//img
import QuestionDrag from "../../Assets/question-drag.svg";
import OptionDel from "../../Assets/del-question.svg";
import OptionAdd from "../../Assets/circle-add.svg";

function Questions(props) {
  const [InputType, setInputType] = useState("");
  const [Category, setCategory] = useState("");
  const [CategoryID, setCategoryID] = useState("");
  const [Type, setType] = useState("");
  const [Title, setTitle] = useState("");
  const [TitleError, setTitleError] = useState("");
  const [webViewUrl, setWebViewUrl] = useState("");
  const [webViewUrlError, setWebViewUrlError] = useState("");
  const [PlaceholderText, setPlaceholderText] = useState("");
  const [PlaceholderTextError, setPlaceholderTextError] = useState("");
  const [ErrorText, setErrorText] = useState("");
  const [ErrorTextError, setErrorTextError] = useState("");
  const [MinValidation, setMinValidation] = useState("");
  const [MinValidationError, setMinValidationError] = useState("");
  const [MaxValidationError, setMaxValidationError] = useState("");
  const [MaxValidation, setMaxValidation] = useState("");
  const [TypeID, setTypeID] = useState("");
  const [fields, setFields] = useState([
    { id: 0, title: null, order_number: 1, is_deleted: 0 },
  ]);
  const [OpenModal, setModal] = useState(false);
  const [clear, setClear] = useState(false);

  const colourStyles = {
    control: (styles, state) => ({
      ...styles,
      backgroundColor: "#3C3C3C",
      border: state.isFocused ? "1px solid #A0A0A0" : "1px solid #3C3C3C",
      transition: "all 0.25s linear 0s",
      "&:hover": {
        border: "1px solid #A0A0A0",
      },
      padding: "4px 6px",
      boxShadow: state.isFocused ? null : null,
    }),
    singleValue: (baseStyles, state) => ({
      ...baseStyles,
      color: state.isFocused ? "#ffffff" : "#ffffff",
      backgroundColor: "#3C3C3C",
    }),
  };

  const TypeOptions = [
    { value: "Subjective", label: "Subjective", id: "1" },
    { value: "Radio", label: "Radio", id: "3" },
    { value: "Dropdown", label: "Dropdown", id: "4" },
    { value: "CameraPhoto", label: "CameraPhoto", id: "5" },
    { value: "Spreadsheet", label: "Spreadsheet", id: "8" },
    // { value: 'WebView', label: 'WebView', id:'6' }
  ];
  const TypeOptions2 = [
    { value: "Subjective", label: "Subjective", id: "1" },
    { value: "Radio", label: "Radio", id: "3" },
    { value: "Dropdown", label: "Dropdown", id: "4" },
    { value: "Checkbox", label: "Checkbox", id: "7" },
  ];

  const InputTypeOptions = [
    { value: "WrittenAmount", label: "WrittenAmount" },
    { value: "NumericAmount", label: "NumericAmount" },
    { value: "DateTime", label: "DateTime" },
    { value: "MonthYear", label: "MonthYear" },
    { value: "Sentence", label: "Sentence" },
    { value: "Noun", label: "Noun" },
    { value: "Decimal", label: "Decimal" },
    { value: "Numeric", label: "Numeric" },
    { value: "Address", label: "Address" },
    { value: "OnFleetInstructions", label: "OnFleetInstructions" },
    { value: "UserName", label: "UserName" },
    { value: "UserAddress", label: "UserAddress" },
    { value: "UserAccountNumber", label: "UserAccountNumber" },
    { value: "Mobile", label: "Mobile" },
    { value: "Email", label: "Email" },
    { value: "CameraPhoto", label: "Photo" },
    { value: "WebView", label: "WebView" },
    { value: "Spreadsheet", label: "CSV/EXCEL" },
    { value: "None", label: "None" },
  ];

  const CategoryOptions = [
    { value: "UserInfo", label: "User Information Section", id: 0 },
    { value: "ServiceInfo", label: "Service Information Section", id: 1 },
    { value: "DeliveryInfo", label: "Delivery Information Section", id: 2 },
  ];

  const handleTitle = (e) => {
    if (e.target.value.length < 256) {
      setTitle(e.target.value);
      setTitleError("");
    } else {
      setTitleError("Max 255 characters");
    }
  };

  const handleWebUrl = (e) => {
    setWebViewUrl(e.target.value);
    setWebViewUrlError("");
  };

  const handleErrorText = (e, INPUT_TYPE) => {
    if (INPUT_TYPE === "WebView") {
      setErrorTextError("");
    }
    if (e.target.value.length < 256) {
      setErrorText(e.target.value);
      setErrorTextError("");
    } else {
      setErrorTextError("Max 255 characters");
    }
  };

  const handlePlaceholderText = (e) => {
    if (e.target.value.length < 256) {
      setPlaceholderText(e.target.value);
      setPlaceholderTextError("");
    } else {
      setPlaceholderTextError("Max 255 characters");
    }
  };

  const handleChange = (selected, type) => {
    if (type === "input_type") {
      setInputType(selected.value);
      if (selected.value === "CameraPhoto") {
        setTypeID("5");
      } else if (selected.value === "WebView") {
        setTypeID("6");
      } else if (selected.value === "Spreadsheet") {
        //alert(selected.value);
        setTypeID("8");
      } else {
        setTypeID("");
      }
    } else if (type === "category") {
      setCategory(selected.value);
      setCategoryID(selected.id);
      return;
    } else {
      setType(selected);
      setTypeID(selected.id);
    }
    setTitle("");
    setTitleError("");
    setWebViewUrl("");
    setWebViewUrlError("");
    setPlaceholderText("");
    setPlaceholderTextError("");
    setErrorText("");
    setErrorTextError("");
    setMinValidation("");
    setMinValidationError("");
    setMaxValidationError("");
    setMaxValidation("");
  };

  useEffect(() => {
    props.location &&
      props.location.state &&
      props.GetQuestionDetails(props.location.state);
  }, []);

  useEffect(() => {
    if (
      props.details_data &&
      props.details_data.data &&
      props.location.pathname.split("/")[3] === "edit-questions"
    ) {
      setTitle(props.details_data.data && props.details_data.data.title);
      setErrorText(
        props.details_data.data && props.details_data.data.error_text
      );
      setMinValidation(
        props.details_data.data && props.details_data.data.min_validation
      );
      setMaxValidation(
        props.details_data.data && props.details_data.data.max_validation
      );
      props.details_data.data &&
      props.details_data.data.placeholder_text === null
        ? setPlaceholderText("")
        : setPlaceholderText(
            props.details_data.data && props.details_data.data.placeholder_text
          );
      setInputType(
        props.details_data.data && props.details_data.data.input_type
      );
      setTypeID(
        props.details_data.data && props.details_data.data.type.toString()
      );
      setCategory(
        props.details_data.data &&
          CategoryOptions[props.details_data.data.category].value
      );
      setCategoryID(
        props.details_data.data && props.details_data.data.category
      );
      setWebViewUrl(props.details_data.data && props.details_data.data.url);
      let data = [];
      props.details_data.data.options.map((options, index) => {
        data.push({
          id: options.id,
          title: options.option_title,
          order_number: index + 1,
          is_deleted: 0,
        });
      });
      data.length > 0 && setFields(data);
    }
  }, [props.details_data]);

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(fields);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setFields(items);
    passData(items);
  };

  const passData = (items) => {
    let data = [];
    items.map((arr) => {
      let index = items.findIndex((x) => x.id === arr.id);
      let id = items.filter((x) => x.id === arr.id);
      data.push({
        id: arr.id,
        order_number: index + 1,
        title: arr.title,
        is_deleted: arr.is_deleted,
      });
    });
    setFields(data);
  };

  function handleAdd() {
    const values = [...fields];
    values.push({
      id: 0,
      order_number: fields.length + 1,
      title: null,
      is_deleted: 0,
    });
    setFields(values);
  }

  function handleRemove(question) {
    if (question.id) {
      const InitialArray = [...fields];
      question.is_deleted = 1;
      let index = InitialArray.findIndex(function (o) {
        return o.id === question.id;
      });
      if (index !== -1) fields.splice(index, 1);
      setFields(InitialArray);
    } else {
      const InitialArray = [...fields];
      let index = fields.findIndex(function (o) {
        return o.order_number === question.order_number;
      });
      if (index !== -1) InitialArray.splice(index, 1);
      setFields(InitialArray);
    }
  }

  const handleOptionTitle = (i, e) => {
    const values = [...fields];
    values[i].title = e.target.value;
    setFields(values);
  };

  const handleModal = (e, type, input_type) => {
    if (
      Title.length < 3 ||
      PlaceholderText.length < 5 ||
      (ErrorText !== null &&
        ErrorText.length < 5 &&
        input_type !== "WebView") ||
      MinValidation < 0 ||
      MaxValidation < 0 ||
      (MinValidation !== null && MinValidation.length > 16) ||
      (MaxValidation !== null && MaxValidation.length > 16)
    ) {
      if (Title.length < 3) {
        setTitleError("Minimum 3 characters");
        setTimeout(() => {
          setTitleError("");
        }, 10000);
      }
      if (PlaceholderText.length < 5) {
        setPlaceholderTextError("Minimum 5 characters");
        setTimeout(() => {
          setPlaceholderTextError("");
        }, 10000);
      }
      if (ErrorText.length < 5 && input_type !== "WebView") {
        setErrorTextError("Minimum 5 characters");
        setTimeout(() => {
          setErrorTextError("");
        }, 10000);
      }
      if (MinValidation < 0 || MinValidation.length > 16) {
        setMinValidationError(
          "Min Validation must be between 0-9999999999999999"
        );
        setTimeout(() => {
          setMinValidationError("");
        }, 10000);
      }
      if (MaxValidation < 0 || MaxValidation.length > 16) {
        setMaxValidationError(
          "Max Validation must be between 0-9999999999999999"
        );
        setTimeout(() => {
          setMaxValidationError("");
        }, 10000);
      }
    } else {
      setTitleError("");
      setPlaceholderTextError("");
      setErrorTextError("");
      setMinValidationError("");
      setMaxValidationError("");
      setModal(type);
    }
  };

  const CloseModal = (e, type) => {
    e.preventDefault();
    if (type === "add_yes") {
      const fieldsArray = [];
      fields.map((array) => {
        fieldsArray.push(array.title);
      });
      const data = {
        title: Title,
        error_text: ErrorText,
        placeholder_text: PlaceholderText,
        min_validation: MinValidation,
        max_validation: MaxValidation,
        type: TypeID,
        input_type: InputType,
        url: webViewUrl,
        options: fieldsArray,
        category: CategoryID,
      };
      props.AddQuestion(data);
      setModal(false);
      props.history.push({
        pathname: "/dashboard/questions",
        back: "yes",
        method: "add",
      });
    } else if (type === "add_no") {
      setModal(false);
    } else if (type === "update_yes") {
      const data = {
        id: props.location.state,
        title: Title,
        error_text: ErrorText,
        placeholder_text: PlaceholderText,
        min_validation: MinValidation,
        max_validation: MaxValidation,
        type: TypeID,
        input_type: InputType,
        url: webViewUrl,
        options: fields,
        category: CategoryID,
      };
      props.EditQuestions(data);
      setModal(false);
      props.history.push({
        pathname: "/dashboard/questions",
        back: "yes",
        method: "update",
      });
    } else if (type === "update_no") {
      setModal(false);
    } else if (type === "delete_yes") {
      props.DeleteQuestion(props.location.state);
      setModal(false);
      props.history.push({
        pathname: "/dashboard/questions",
        back: "yes",
        method: "delete",
      });
    } else if (type === "delete_no") {
      setModal(false);
    }
  };
  return (
    <>
      {props.loading && <Loader />}
      <div className="action-wrap">
        <div className="d-flex justify-content-between align-items-center head-wrap mb-4">
          <div
            onClick={() => {
              setClear(!clear);
              props.history.push({
                pathname: "/dashboard/questions",
                clear: !clear,
              });
            }}
            className="d-flex head-left cursor-pointer"
          >
            <img src={Chevron} alt="Chevron" />
            <span className="text-nowrap text-white f-20 pl-3 text-uppercase">
              {props.location.pathname.split("/")[3] === "edit-questions"
                ? "Edit"
                : "Add"}{" "}
              Question
            </span>
          </div>
        </div>

        <div className="mt-4">
          <label className="text-grey-6 f-16 d-block mb-1">
            Input Type<span className="text-danger">*</span>
          </label>
          <Select
            onChange={(e) => handleChange(e, "input_type")}
            options={InputTypeOptions}
            styles={colourStyles}
            placeholder="Select Type"
            value={InputTypeOptions.filter(function (option) {
              return option.value === InputType;
            })}
          />
        </div>

        <div className="mt-4">
          <label className="text-grey-6 f-16 d-block mb-1">
            Category<span className="text-danger">*</span>
          </label>
          <Select
            onChange={(e) => handleChange(e, "category")}
            options={CategoryOptions}
            styles={colourStyles}
            placeholder="Select Category"
            value={CategoryOptions.filter(function (option) {
              console.log(option.value === Category);
              return option.value === Category;
            })}
          />
        </div>

        {InputType !== "WebView" &&
          InputType !== "CameraPhoto" &&
          InputType !== "Spreadsheet" && (
            <div className="mt-4">
              <label className="text-grey-6 f-16 d-block mb-1">
                Type<span className="text-danger">*</span>
              </label>
              <Select
                onChange={(e) => handleChange(e, "type")}
                options={
                  InputType === "CameraPhoto" ? TypeOptions : TypeOptions2
                }
                styles={colourStyles}
                placeholder="Select Type"
                value={(InputType === "CameraPhoto"
                  ? TypeOptions
                  : TypeOptions2
                ).filter(function (option) {
                  return option.id === TypeID;
                })}
              />
            </div>
          )}
        {(TypeID === "3" || TypeID === "4" || TypeID === "7") && (
          <div className="mt-4">
            <DragDropContext onDragEnd={handleOnDragEnd}>
              <Droppable droppableId="home_listing" type="listing">
                {(provided) => (
                  <div {...provided.droppableProps} ref={provided.innerRef}>
                    {fields.length > 0 &&
                      fields.map((Option, index) => {
                        return (
                          Option.is_deleted !== 1 && (
                            <Draggable
                              key={index + 1}
                              draggableId={(index + 1).toString()}
                              index={index}
                            >
                              {(provided) => (
                                <div
                                  className="mt-2"
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  key={index}
                                >
                                  <div className="d-flex align-items-center">
                                    <div
                                      className="d-flex align-items-center pl-3 w-100"
                                      style={{ background: "#3C3C3C" }}
                                    >
                                      <img
                                        src={QuestionDrag}
                                        alt="QuestionDrag"
                                      />
                                      {TypeID === "3" && (
                                        <img
                                          src={Radio}
                                          className="ml-5"
                                          alt="radio"
                                        />
                                      )}
                                      <input
                                        type="text"
                                        placeholder="Enter text"
                                        className="w-100 border-0"
                                        onChange={(e) =>
                                          handleOptionTitle(index, e)
                                        }
                                        value={Option.title || ""}
                                      />
                                    </div>
                                    {index === 0 && (
                                      <img
                                        onClick={() => handleAdd()}
                                        src={OptionAdd}
                                        className="ml-4 cursor-pointer"
                                        alt="QuestionDrag"
                                      />
                                    )}
                                    {index !== 0 && (
                                      <img
                                        onClick={() => handleRemove(Option)}
                                        src={OptionDel}
                                        className="ml-4 cursor-pointer"
                                        alt="QuestionDrag"
                                      />
                                    )}
                                  </div>
                                </div>
                              )}
                            </Draggable>
                          )
                        );
                      })}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        )}
        {InputType === "WebView" && (
          <div className="d-flex">
            <div className="w-100 mt-3">
              <label htmlFor="title" className="text-grey-6 f-16 d-block mb-1">
                URL<span className="text-danger">*</span>
              </label>
              <input
                value={webViewUrl}
                onChange={(e) => handleWebUrl(e)}
                type="text"
                id="Photo"
                placeholder="Enter URL"
                className="w-100 input-style text-white"
                autoComplete="off"
              />
              {TitleError && (
                <p className="ml-2 f-12 text-danger">{TitleError}</p>
              )}
            </div>
          </div>
        )}
        {InputType === "CameraPhoto" && (
          <div className="d-flex">
            <div className="w-100 mt-3">
              <label htmlFor="title" className="text-grey-6 f-16 d-block mb-1">
                Type<span className="text-danger">*</span>
              </label>
              <input
                value={"CameraPhoto"}
                type="text"
                id="Photo"
                disabled
                placeholder="Enter URL"
                className="w-100 input-style text-white"
                autoComplete="off"
              />
              {TitleError && (
                <p className="ml-2 f-12 text-danger">{TitleError}</p>
              )}
            </div>
          </div>
        )}
        {InputType === "Spreadsheet" && (
          <div className="d-flex">
            <div className="w-100 mt-3">
              <label htmlFor="title" className="text-grey-6 f-16 d-block mb-1">
                Type<span className="text-danger">*</span>
              </label>
              <input
                value={"Spreadsheet"}
                type="text"
                id="CSV/EXCEL"
                disabled
                placeholder="Enter URL"
                className="w-100 input-style text-white"
                autoComplete="off"
              />
              {TitleError && (
                <p className="ml-2 f-12 text-danger">{TitleError}</p>
              )}
            </div>
          </div>
        )}
        <div className="d-flex">
          <div className="w-50 mr-3">
            <label htmlFor="title" className="text-grey-6 f-16 d-block mb-1">
              Title<span className="text-danger">*</span>
            </label>
            <input
              value={Title}
              onChange={(e) => handleTitle(e)}
              type="text"
              id="title"
              placeholder="Enter Title"
              className="w-100 input-style"
              autoComplete="off"
            />
            {TitleError && (
              <p className="ml-2 f-12 text-danger">{TitleError}</p>
            )}
          </div>
          <div className="w-50 ml-3">
            <label
              htmlFor="errorText"
              className="text-grey-6 f-16 d-block mb-1"
            >
              Error Text
              {InputType !== "WebView" && (
                <span className="text-danger">*</span>
              )}
            </label>
            <input
              value={ErrorText}
              onChange={(e) => handleErrorText(e, InputType)}
              type="text"
              id="errorText"
              disabled={InputType === "WebView"}
              placeholder="Enter Error Text"
              className="w-100 input-style"
              autoComplete="off"
            />
            {ErrorTextError && (
              <p className="ml-2 f-12 text-danger">{ErrorTextError}</p>
            )}
          </div>
        </div>
        <div className="d-flex mt-4">
          <div className="w-50 mr-3">
            <div className="d-flex">
              <div className="w-50 mr-2">
                <label
                  htmlFor="MinValidation"
                  className="text-grey-6 f-16 d-block mb-1"
                >
                  MinValidation
                  {InputType !== "CameraPhoto" && InputType !== "WebView" && (
                    <span className="text-danger">*</span>
                  )}
                </label>
                <input
                  value={MinValidation}
                  onChange={(e) => setMinValidation(e.target.value)}
                  type="text"
                  id="MinValidation"
                  disabled={
                    InputType === "CameraPhoto" ||
                    InputType === "WebView" ||
                    InputType === "Spreadsheet"
                  }
                  placeholder="Enter MinValidation"
                  className="w-100 input-style"
                  autoComplete="off"
                />
                {MinValidationError && (
                  <p className="ml-2 f-12 text-danger">{MinValidationError}</p>
                )}
              </div>
              <div className="w-50 ml-2">
                <label
                  htmlFor="MaxValidation"
                  className="text-grey-6 f-16 d-block mb-1"
                >
                  MaxValidation
                  {InputType !== "CameraPhoto" && InputType !== "WebView" && (
                    <span className="text-danger">*</span>
                  )}
                </label>
                <input
                  value={MaxValidation}
                  onChange={(e) => setMaxValidation(e.target.value)}
                  type="text"
                  id="MaxValidation"
                  disabled={
                    InputType === "CameraPhoto" ||
                    InputType === "WebView" ||
                    InputType === "Spreadsheet"
                  }
                  placeholder="Enter MaxValidation"
                  className="w-100 input-style"
                  autoComplete="off"
                />
                {MaxValidationError && (
                  <p className="ml-2 f-12 text-danger">{MaxValidationError}</p>
                )}
              </div>
            </div>
          </div>
          <div className="w-50 ml-3">
            <label
              htmlFor="PlaceholderText"
              className="text-grey-6 f-16 d-block mb-1"
            >
              Placeholder Text<span className="text-danger">*</span>
            </label>
            <input
              value={PlaceholderText}
              onChange={(e) => handlePlaceholderText(e)}
              type="text"
              id="PlaceholderText"
              placeholder="Enter Placeholder Text"
              className="w-100 input-style"
              autoComplete="off"
            />
            {PlaceholderTextError && (
              <p className="ml-2 f-12 text-danger">{PlaceholderTextError}</p>
            )}
          </div>
        </div>
        <div className="d-flex justify-content-between mt-5">
          {props.location.pathname.split("/")[3] === "edit-questions" && (
            <>
              <button
                onClick={(e) => handleModal(e, "delete")}
                className="form-button mr-3"
              >
                Delete
              </button>
              {TypeID === "3" || TypeID === "4" ? (
                <button
                  disabled={
                    InputType === "CameraPhoto"
                      ? !(
                          Title &&
                          ErrorText &&
                          PlaceholderText &&
                          InputType &&
                          TypeID
                        )
                      : InputType === "WebView"
                      ? !(
                          Title &&
                          PlaceholderText &&
                          InputType &&
                          TypeID &&
                          webViewUrl
                        )
                      : !(
                          Title &&
                          ErrorText &&
                          MinValidation &&
                          MaxValidation &&
                          PlaceholderText &&
                          InputType &&
                          TypeID
                        ) ||
                        fields[0].title === null ||
                        fields[0].title === ""
                  }
                  onClick={(e) => handleModal(e, "update")}
                  className="form-button ml-3"
                >
                  Update
                </button>
              ) : (
                <button
                  disabled={
                    InputType === "CameraPhoto"
                      ? !(
                          Title &&
                          ErrorText &&
                          PlaceholderText &&
                          InputType &&
                          TypeID
                        )
                      : InputType === "WebView"
                      ? !(
                          Title &&
                          PlaceholderText &&
                          InputType &&
                          TypeID &&
                          webViewUrl
                        )
                      : InputType === "Spreadsheet"
                      ? !(Title && PlaceholderText && InputType && TypeID)
                      : !(
                          Title &&
                          ErrorText &&
                          MinValidation &&
                          MaxValidation &&
                          PlaceholderText &&
                          InputType
                        )
                  }
                  onClick={(e) => handleModal(e, "update")}
                  className="form-button ml-3"
                >
                  Update
                </button>
              )}
            </>
          )}
          {props.location.pathname.split("/")[3] === "add-questions" && (
            <>
              <button
                // disabled={
                //   InputType === "CameraPhoto"
                //     ? !(
                //         Title &&
                //         ErrorText &&
                //         PlaceholderText &&
                //         InputType &&
                //         TypeID
                //       )
                //     : InputType === "WebView"
                //     ? !(Title && PlaceholderText && InputType && TypeID)
                //     : !(
                //         Title ||
                //         ErrorText ||
                //         MinValidation ||
                //         MaxValidation ||
                //         PlaceholderText ||
                //         InputType ||
                //         TypeID
                //       )
                // }
                onClick={() =>
                  props.history.push({
                    pathname: "/dashboard/questions",
                    back: "yes",
                  })
                }
                className="form-button mr-3"
              >
                Cancel
              </button>
              {TypeID === "3" || TypeID === "4" ? (
                <button
                  disabled={
                    InputType === "CameraPhoto"
                      ? !(
                          Title &&
                          ErrorText &&
                          PlaceholderText &&
                          InputType &&
                          TypeID
                        )
                      : InputType === "WebView"
                      ? !(Title && PlaceholderText && InputType && TypeID)
                      : InputType === "Spreadsheet"
                      ? !(Title && PlaceholderText && InputType && TypeID)
                      : !(
                          Title &&
                          ErrorText &&
                          MinValidation &&
                          MaxValidation &&
                          PlaceholderText &&
                          InputType &&
                          TypeID
                        ) ||
                        fields[0].title === null ||
                        fields[0].title === ""
                  }
                  onClick={(e) => handleModal(e, "add", InputType)}
                  className="form-button ml-3"
                >
                  Save
                </button>
              ) : (
                <button
                  disabled={
                    InputType === "CameraPhoto"
                      ? !(
                          Title &&
                          ErrorText &&
                          PlaceholderText &&
                          InputType &&
                          TypeID
                        )
                      : InputType === "WebView"
                      ? !(Title && PlaceholderText && InputType && TypeID)
                      : InputType === "Spreadsheet"
                      ? !(Title && PlaceholderText && InputType && TypeID)
                      : !(
                          Title &&
                          ErrorText &&
                          MinValidation &&
                          MaxValidation &&
                          PlaceholderText &&
                          InputType &&
                          TypeID
                        )
                  }
                  // disabled={
                  //   !(
                  //     Title &&
                  //     ErrorText &&
                  //     MinValidation &&
                  //     MaxValidation &&
                  //     PlaceholderText &&
                  //     InputType &&
                  //     TypeID
                  //   )
                  // }
                  onClick={(e) => handleModal(e, "add", InputType)}
                  className="form-button ml-3"
                >
                  Save
                </button>
              )}
            </>
          )}
        </div>
        <Style />
        {OpenModal && (
          <Modal
            Name={Title}
            Type={OpenModal}
            Close={(e, type) => CloseModal(e, type)}
          />
        )}
      </div>
    </>
  );
}

const mapStateToProps = ({ QuestionReducer }) => {
  const { loading, data, details_data } = QuestionReducer;
  return { loading, data, details_data };
};

const mapDispatchToProps = {
  AddQuestion,
  GetQuestionDetails,
  EditQuestions,
  DeleteQuestion,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Questions));
